export enum OnboardingEvents {
  RESEND_VERIFICATION_EMAIL = 'ONBOARDING:resend_verification_email',
  RESEND_VERIFICATION_EMAIL_ERROR = 'ONBOARDING:resend_verification_email_error',
  CLICKED_LOGOUT = 'ONBOARDING:clicked_logout',
  CHOOSED_PROFILE_TYPE = 'ONBOARDING:choosed_profile_type',
  VERIFIED_EDUCATIONAL_EMAIL = 'ONBOARDING:verified_educational_email',
  VERIFIED_EDUCATIONAL_EMAIL_FAILED = 'ONBOARDING:verified_educational_email_failed',
  SENT_VERIFICATION_EMAIL = 'ONBOARDING:sent_educational_email',
  SENT_VERIFICATION_EMAIL_ERROR = 'ONBOARDING:sent_educational_email_error',
  ACCOUNT_CREATED = 'ONBOARDING:account_created',
  ACCOUNT_CREATED_ERROR = 'ONBOARDING:account_created_error',
}
